import {
  CheckboxGroup,
  Checkbox
} from './styles'

CheckboxGroup.Box = Checkbox

export default CheckboxGroup
